import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ColumnManageComponent } from '../popover/column-manage/column-manage.component';
import { LeadOptionComponent } from '../popover/lead-option/lead-option.component';
import { TableColumnOptionsComponent } from '../popover/table-column-options/table-column-options.component';
import { TABLE_OPTION_VALUES } from '../constants/api-constants';
import { GlobalService } from '../services/global/global.service';
import { ModalsService } from '../services/modals/modals.service';

@Component({
  selector: 'app-grid-view',
  templateUrl: './grid-view.component.html',
  styleUrls: ['./grid-view.component.scss'],
})
export class GridViewComponent implements OnInit {

  @Input() allData: any;
  @Input() data: any;
  hidePaginations: boolean = false;
  @Input() hidePaginationHard: boolean = false;
  @Input() showStatusDropdown: boolean = false;
  @Input() showToggleBtn: boolean = false;
  paginationSettings: any;
  visiblePages: number[] = [];
  noOfRows: any = 0;
  @Input() entityName: any;

  @Input() columns: any = [];
  @Input() showColumnSelector: boolean = false;
  // Following property name is base for multi select, create a list of selected items (values with given propertyName) and emit them to parent component when respective event is triggered

  @Input() optionsValues: any;
  @Input() hideSortBtn: any = false;

  @Input() showWhatsappActionBtn: boolean = false;
  @Input() showEmailActionBtn: boolean = false;

  @Output() triggerDeleteRow = new EventEmitter<void>();
  @Output() triggerEditRow = new EventEmitter<void>();
  @Output() triggerViewRow = new EventEmitter<void>();
  @Output() triggerTaskRow = new EventEmitter<void>();
  @Output() triggerAddPaymentRow = new EventEmitter<void>();
  @Output() triggerApproveRow = new EventEmitter<void>();
  @Output() triggerDownloadRow = new EventEmitter<void>();
  @Output() triggerAduitHistoryRow = new EventEmitter<void>();
  @Output() triggerCloneRow = new EventEmitter<void>();
  @Output() paginationsUpdated = new EventEmitter<void>();
  @Output() emitRowOnCellClicked = new EventEmitter<any>();
  @Output() triggerStatusChange = new EventEmitter<any>();
  @Output() triggerToggleChange = new EventEmitter<any>();
  @Output() manageColumnsChange = new EventEmitter<any>();
  @Output() emitSelectedRows = new EventEmitter<any[]>();
  @Output() emitWhatsappActionTrigger = new EventEmitter<any[]>();
  @Output() emitEmailActionTrigger = new EventEmitter<any[]>();
  @Output() emitCallActionTrigger = new EventEmitter<any[]>();


  initialColumns: any = [];

  // Keep track of the current sort order for each column
  sortOrder: { [key: string]: 'asc' | 'desc' } = {};

  @Input() columnsToFreeze: number = 0;

  // Multi select related variables
  selectedRowIds: any[] = [];
  @Input() multiSelectProperty: string | null = null;

  constructor(
    private _popOverController: PopoverController,
    private _globalService: GlobalService,
    private _modalPopupService: ModalsService

  ) { }

  ngOnInit() {
    this.initialColumns = this.getVisibleColumns(this.columns);
  }

  ngOnChanges() {
    this.data = this.allData?.data;

    this.paginationSettings = this.allData;

    // Reset selected rows when data changes
    this.selectedRowIds = [];

    if (this.data && this.data.length) {
      delete this.paginationSettings.data;
      this.noOfRows = this.data.length;
      this.updateVisiblePages();
    }

    if (this.data && this.data.length === 0) {
      this.hidePaginations = true;
    } else {
      this.hidePaginations = false;
    }
  }

  getTHColumnClasses(cssClass: string | undefined, index: number): { [key: string]: boolean } {
    const classes = {
      [cssClass || '']: !!cssClass,
      'freeze-column': index < this.columnsToFreeze,
    };
    if (index < this.columnsToFreeze) {
      classes[`freeze-column-${index + 1}`] = true;
    }
    return classes;
  }

  getTDColumnClasses(index: number): { [key: string]: boolean } {
    const classes: any = {
      'freeze-column': index < this.columnsToFreeze,
    };
    if (index < this.columnsToFreeze) {
      classes[`freeze-column-${index + 1}`] = true;
    }
    return classes;
  }

  getfullColSpan() {
    let colspan = this.initialColumns.length
    if (this.showColumnSelector) {
      colspan = colspan + 1;
    }
    if (this.optionsValues) {
      colspan = colspan + 1;
    }

    return colspan;
  }


  onCellClick(row: any, clickedItem: any) {
    this.emitRowOnCellClicked.emit({ row: row, clickedItem: clickedItem });
  }

  async openColumnOptions(ev: any) {
    const columnPopOver = await this._popOverController.create({
      component: ColumnManageComponent,
      event: ev,
      componentProps: { columns: this.columns },
      cssClass: "popup-component"
    })
    await columnPopOver.present();
    const { data } = await columnPopOver.onDidDismiss();
    if (data) {
      this.initialColumns = data;
      this.initialColumns = data.filter((column: { showColumn: any; }) => column.showColumn);
      this.manageColumnsChange.emit(data);
    } else {
      this.resetColumn();
      this.ngOnInit();
    }
  }

  async optionsPopOver(event: any) {
    const popover = await this._popOverController.create({
      component: LeadOptionComponent,
      event: event,
      cssClass: "popup-component"
    })
    await popover.present()

  }

  resetColumn() {
    this.initialColumns = this.columns.filter((column: { showColumn: any; }) => column.showColumn);
  }

  getVisibleColumns(columns: any) {
    return columns.filter((column: { showColumn: any; }) => column.showColumn);
  }

  sortData(column: string) {
    // Toggle sort order
    this.sortOrder[column] = this.sortOrder[column] === 'asc' ? 'desc' : 'asc';

    const order = this.sortOrder[column];

    this.data.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const valueA = a[column];
      const valueB = b[column];

      let comparison = 0;

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        comparison = valueA.localeCompare(valueB);
      } else if (typeof valueA === 'number' && typeof valueB === 'number') {
        comparison = valueA - valueB;
      } else if (valueA instanceof Date && valueB instanceof Date) {
        comparison = valueA.getTime() - valueB.getTime();
      }

      return order === 'asc' ? comparison : -comparison;
    });
  }


  // Options POP over

  async showOptions(ev: any, row: any) {
    const popover = await this._popOverController.create({
      component: TableColumnOptionsComponent,
      event: ev,
      cssClass: 'popup-component',
      componentProps: {
        optionsData: this.optionsValues,
        onPathSelected: (data: any) => this.onOptionSelected(data, row) // Ensure the function is passed correctly
      }
    });
    return await popover.present();
  }

  closeOptions() {
    this._popOverController.dismiss();
  }

  onOptionSelected(data: any, row: any) {
    switch (data.path) {
      case TABLE_OPTION_VALUES.DELETE: {
        this.triggerDeleteRow.emit(row[data.id]);
        break;
      }
      case TABLE_OPTION_VALUES.EDIT: {
        this.triggerEditRow.emit(row[data.id]);
        break;
      }
      case TABLE_OPTION_VALUES.VIEW: {
        this.triggerViewRow.emit(row[data.id]);
        break;
      }
      case TABLE_OPTION_VALUES.TASK: {
        this.triggerTaskRow.emit(row[data.id]);
        break;
      }
      case TABLE_OPTION_VALUES.ADD_PAYMENT: {
        this.triggerAddPaymentRow.emit(row[data.id]);
        break;
      }
      case TABLE_OPTION_VALUES.APPROVE: {
        this.triggerApproveRow.emit(row[data.id]);
        break;
      }
      case TABLE_OPTION_VALUES.DOWNLOAD: {
        this.triggerDownloadRow.emit(row[data.id]);
        break;
      }
      case TABLE_OPTION_VALUES.SHOW_AUDIT: {
        this.triggerAduitHistoryRow.emit(row[data.id]);
        break;
      }
      case TABLE_OPTION_VALUES.MAKE_A_CLONE: {
        this.triggerCloneRow.emit(row[data.id]);
      }
    }
    this.closeOptions();
  }

  // status changed
  statusChanged(event: any, row: any) {
    let res = {
      statusValue: event.target.value,
      row: row
    }
    this.triggerStatusChange.emit(res);
  }

  onToggleChange(event: any, row: any) {
    row.status = event ? 'Active' : 'Inactive'; // Ensure it's string
    let res = {
      status: row.status, // New toggle value
      row: row
    };
    this.triggerToggleChange.emit(res);
  }

  // Multi select variables

  // Check if all rows are selected
  isAllSelected(): boolean {
    if (!this.data || !this.multiSelectProperty) return false;
    return this.data.length > 0 && this.selectedRowIds.length === this.data.length;
  }

  // Toggle all rows
  toggleSelectAllRows(event: any) {
    if (event.target.checked) {
      this.selectedRowIds = this.data.map((row: any) => row[this.multiSelectProperty as string]);
    } else {
      this.selectedRowIds = [];
    }
    this.emitSelectedRows.emit(this.getSelectedRows());
  }

  // Toggle single row
  toggleSelectRow(event: any, row: any) {
    const id = row[this.multiSelectProperty as string];
    if (event.target.checked) {
      if (!this.selectedRowIds.includes(id)) {
        this.selectedRowIds.push(id);
      }
    } else {
      this.selectedRowIds = this.selectedRowIds.filter(selectedId => selectedId !== id);
    }
    this.emitSelectedRows.emit(this.getSelectedRows());
  }

  // Utility to check if a row is selected
  isRowSelected(row: any): boolean {
    return this.selectedRowIds.includes(row[this.multiSelectProperty as string]);
  }

  getSelectedRows(): any[] {
    if (!this.data || !this.multiSelectProperty) {
      return [];
    }
    // Only return selected rows that are present in the current page's data
    const selectedRows = this.data.filter((row: any) =>
      this.selectedRowIds.includes(row[this.multiSelectProperty as string])
    );
    return selectedRows;
  }

  areRowsSelected(): boolean {
    if (this.selectedRowIds && this.selectedRowIds.length > 0) {
      return true;
    }
    return false;
  }

  
  //////////////
  // Paginations
  //////////////
  updateVisiblePages() {
    const currentPage = this.paginationSettings.pageNumber;
    const totalPages = this.paginationSettings.totalPages;

    let startPage: number, endPage: number;
    if (totalPages <= 5) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage + 2 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } else {
        startPage = currentPage - 2;
        endPage = currentPage + 2;
      }
    }

    this.visiblePages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);
  }

  onPageChange(page: number) {
    if (page !== this.paginationSettings.pageNumber) {
      this.paginationSettings.pageNumber = page;
      this.updateVisiblePages();
      this.loadPageData();
    }
  }

  onNext() {
    if (this.paginationSettings.pageNumber < this.paginationSettings.totalPages) {
      this.paginationSettings.pageNumber++;
      this.updateVisiblePages();
      this.loadPageData();
    }
  }

  onPrevious() {
    if (this.paginationSettings.pageNumber > 1) {
      this.paginationSettings.pageNumber--;
      this.updateVisiblePages();
      this.loadPageData();
    }
  }

  onPageSizeChange() {
    this.paginationSettings.pageNumber = 1;
    this.updateVisiblePages();
    this.loadPageData();
  }

  loadPageData() {
    this.paginationsUpdated.emit(this.paginationSettings);
  }

  getStatusColor(statusValue: string): string {
    return this._globalService.getStatusColorFromValue(statusValue);
  }
openSourceImage(imageUrl: string) {
  if (!imageUrl) {
    return;
  }

  this._modalPopupService.openImageModal(imageUrl);
}

}
